import { render, staticRenderFns } from "./PscInspectionByCountry.vue?vue&type=template&id=f9c63656&scoped=true&"
import script from "./PscInspectionByCountry.vue?vue&type=script&lang=js&"
export * from "./PscInspectionByCountry.vue?vue&type=script&lang=js&"
import style0 from "./PscInspectionByCountry.vue?vue&type=style&index=0&id=f9c63656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c63656",
  null
  
)

export default component.exports